import type { FaireProductEntity } from "../../entity_types/product";

export const p_aqacc8k6uw: FaireProductEntity = {
  token: "p_aqacc8k6uw",
  type: "product",
  name: "BUTTON DOWN CAP SLEEVE SWEATER - 6482W",
  brandToken: "b_8tg8mxotwp",
  brandName: "PINCH",
  imageUrl:
    "https://cdn.faire.com/fastly/c82b9aa06209840aeea04a70f94a5435f2e53a27f62aee95e24b6661be889a8c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2fe0e0e9eefe1e83e319837b7322101d51b8c6989b1e3630f68b8983a1bd2eb4.jpeg",
    "https://cdn.faire.com/fastly/3c0d133e879c79a9667ae0b45cc2650ed89d9ef1dc5ee6ab4d551407e34086f6.jpeg",
    "https://cdn.faire.com/fastly/b30be416121f809c82e11e927942d4dfa03d56264d4490dc5b54ce5fe1f163f3.jpeg",
    "https://cdn.faire.com/fastly/32bb482aa96b9497785b0453fa151633e8e89a3a729b2e95f2a1711b043f6432.jpeg",
    "https://cdn.faire.com/fastly/2d5ecdf369f24c26a3de27a21012de01cd4e8dd79811189582fb98621b35699e.jpeg",
    "https://cdn.faire.com/fastly/0b0323a514309fdc97b155e9b95f14b69202858b641397993fa180cf1bba1f81.jpeg",
    "https://cdn.faire.com/fastly/891080bfbe227fb27075082d0066f427a411d1db28237cbc4492d07d566b5cab.jpeg",
    "https://cdn.faire.com/fastly/ef71d9eb08625f409b474c3e4cba27ec757aaf638bbd41432396724c8c5881ea.jpeg",
    "https://cdn.faire.com/fastly/df1f10b1ae66631c807be95ec877ee25ddd20415da897105bfb550653144b63c.jpeg",
    "https://cdn.faire.com/fastly/f4f3b3b000d8bfff74f48510339685a368b0373f8c2c7c2b6f67e501da459707.jpeg",
    "https://cdn.faire.com/fastly/dfec30002ff44c8828be28f535b11c8f49f56457dd4bcd7f711381163cd97f47.jpeg",
    "https://cdn.faire.com/fastly/531406b19047d2c76d6cfaf5169d9725834a594727d09fb0e4570930aa2e58fa.jpeg",
    "https://cdn.faire.com/fastly/bc2d5291b9003e6b7411eef1559df0f06cf02405f03d1378627abe610a480690.jpeg",
    "https://cdn.faire.com/fastly/919eca668cb43ca104eb03e0bb27e611beff6fa1a10a5ec14b2f994d2d93f9e4.jpeg",
    "https://cdn.faire.com/fastly/ca2ad306acaa5ef41c98e2cdfaa6b1d33fd2455f8d928ce219024f0cc554d9d4.jpeg",
    "https://cdn.faire.com/fastly/1db96d08339f01c6cef84295afe752043696919726a4a795652506540b0223cd.jpeg",
    "https://cdn.faire.com/fastly/22cae07dbe47425ca37d125ab91c3849ceed93fa63e7708f5cfe3e8c2d439e0d.jpeg",
    "https://cdn.faire.com/fastly/8b61e52998b8732cb8a3550b609eebeffa28d552947a80f4004d475e7e61e64c.jpeg",
    "https://cdn.faire.com/fastly/6eb4befe7b22aab3ed8e92e0cfba924bcee0029a41114ac6cbed4a307fbf0ccc.jpeg",
    "https://cdn.faire.com/fastly/b76d947ef15e93ed7235f1f98a96616d40abcc3fd02defc91884f6aff507496c.jpeg",
    "https://cdn.faire.com/fastly/b0fcfe7331f87bcb4244e7add119cc87b1f3727f59aea11845e7e6af50bcedbb.jpeg",
    "https://cdn.faire.com/fastly/645cdc832fa5cb16437df6a23b12285004f9b7aafbdb400b7347abd7e9607fb7.jpeg",
    "https://cdn.faire.com/fastly/15ca72b958bcb13a499efa3b88e0b6d92321290ac4e2fb0a5b0417bda12d6ecc.jpeg",
    "https://cdn.faire.com/fastly/eb31c6a63b6f86a3d1e0a275d6b4df78b8583bcf2c933e6ca4f9df4ca0e5b54c.jpeg",
    "https://cdn.faire.com/fastly/54b79687462117e0377b5da89e07c50a4530aabf4dca051bc13f06c568ce3688.jpeg",
    "https://cdn.faire.com/fastly/38584c0702846ed340562ace048fd9d8793d2682317c74bfeacb9c558230e3cb.jpeg",
    "https://cdn.faire.com/fastly/17845631cf4035f462acfbc29d7e0119131cafc28c422ab49ff0c317802c9362.jpeg",
    "https://cdn.faire.com/fastly/7b37cc6fd6ec397c44d8ba8f79fcd276b00dfdbe4336d391d577596bf4dd2238.jpeg",
    "https://cdn.faire.com/fastly/b1546af78b8da84329727e361bdc9ac71932d7e985aad96eea1cf375b4c06f22.jpeg",
    "https://cdn.faire.com/fastly/a004eeefb940b725ec2609ca91e6b67f4efb00a226f07e03a08dcc7ab6894891.jpeg",
    "https://cdn.faire.com/fastly/9273c93be72d559ab1d855c06fbf34f2efda7102060077e5d3fbe4e0e3a5c695.jpeg",
    "https://cdn.faire.com/fastly/8e34c74138d4c773663a569ea66951b725bcdf9616211a70807d99a1a2d36a8c.jpeg",
    "https://cdn.faire.com/fastly/88f4f4e59b1430e94285bf6214722fc80833d97dddac3042fc3e05366db444d3.jpeg",
    "https://cdn.faire.com/fastly/c405145af05b900e377b777b40ae9084df1241857f0c35cf3035970128f3314e.jpeg",
  ],
  priceDollars: 154.5,
  description:
    "ROUND NECK\nBUTTON DOWN\nCAP SLEEVE\n\nMODEL WEARS A SIZE SMALL",
  tags: [],
  msrpDollars: 309,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:14:53.084Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
